import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Collapse from 'bootstrap/js/dist/collapse';

function NavMenu()
{   
    const menuOpenDelay = 200;
    const menuCloseDelay = 200;

    const header = document.querySelector('header');
    //const adminBar = document.getElementById('wpadminbar');
    const navMain = document.querySelector(".nav-main");
    const navMainDropdowns = (navMain !== null) ? document.querySelectorAll('.nav-main > .nav-item.dropdown') : null;
    const subNavMainDropdowns = (navMain !== null) ? document.querySelectorAll('.nav-main > .nav-item.dropdown .nav-item.dropdown') : null;

    if (navMain === null || navMainDropdowns === null) {
        return;
    }
    
    let menuTimer = null;
    let menuClosingTimer = null;
    let menuOverlayDiv = null;

    function openNavMainDropdown(event)
    {
        if (!window.matchMedia("only screen and (min-width: 1200px)").matches) {
            return;
        }

        if (menuClosingTimer) {
            clearTimeout(menuClosingTimer);
        }

        menuTimer = setTimeout(() => {
            let menuListItem;
            if (event.type === 'mouseenter') {
                menuListItem = event.target;
            } else if (event.type === 'focus') {
                menuListItem = event.target.closest('li');
            }

            const submenu = menuListItem.querySelector('.dropdown-menu');

            // Close any other menus that are already open
            const parentList = event.target.closest('ul');
            if (parentList !== null) {
                const openedMenus = parentList.querySelectorAll('.is-open');
                if (openedMenus.length > 0) {
                    openedMenus.forEach(element => {
                        // let openedSubmenu = element.querySelector('.submenu-wrapper');
                        // if (openedSubmenu !== null) {
                        //     openedSubmenu.setAttribute('aria-hidden', true);
                        // }
                        if (element !== submenu) {
                            requestAnimationFrame(() => {
                                setTimeout(() => {
                                    element.classList.remove('is-open');
                                    element.setAttribute('aria-expanded', false);
                                }, 0)
                            });
                        }
                    });
                }
            }

            // Open the relevant menu
            if (submenu !== null) {
                // Determine whether to position the menu to the left or right
                const availableWidth = (window.innerWidth - event.target.getBoundingClientRect().right);
                const alignClass = (availableWidth >= 300) ? 'align-end' : 'align-start';

                // const headerHeight = (header !== null) ? header.getBoundingClientRect().bottom : 0 ;

                let menuOverlayFragment = null;
                let menuOverlay = document.querySelector('.desktop-menu-backdrop');
                menuOverlayDiv = (menuOverlay === null) ? document.createElement("div") : null ;
                if (menuOverlayDiv !== null) {
                    menuOverlayDiv.classList.add('desktop-menu-backdrop', 'is-open');
                    menuOverlayFragment = new DocumentFragment();
                    menuOverlayFragment.appendChild(menuOverlayDiv);
                    
                }

                //const scrollbarWidth = (window.innerWidth - document.documentElement.clientWidth);

                requestAnimationFrame(() => {
                    setTimeout(() => {
                        //document.documentElement.classList.add('no-scroll');
                        submenu.classList.add('is-open', alignClass);
                        //document.documentElement.style.marginRight = scrollbarWidth + "px";
                        if (menuOverlayFragment !== null) {
                            document.body.append(menuOverlayFragment);
                            // const menuOverlay = document.querySelector(".desktop-menu-backdrop");
                            // if (menuOverlay !== null) {
                            //     menuOverlay.classList.add('is-open');
                            // }
                        }
                    }, 0)
                });
            }
        },
        menuOpenDelay);
    }


    function closeNavMainDropdown(event)
    {
        if (!window.matchMedia("only screen and (min-width: 1200px)").matches) {
            return;
        }

        if (menuTimer) {
            clearTimeout(menuTimer);
        }

        menuClosingTimer = setTimeout(() => {
            const submenu = event.target.querySelector('.dropdown-menu');
            const menuOverlay = document.querySelector('.desktop-menu-backdrop');
            if (submenu !== null) {
                if (menuOverlay !== null) {
                    menuOverlay.addEventListener('transitionend', event => {
                        menuOverlay.remove();
                        menuOverlay = null;
                    }, {once: true});
                }
                requestAnimationFrame(() => {
                    setTimeout(() => {
                        //document.documentElement.style.marginRight = 0;
                        //document.documentElement.classList.remove('no-scroll');
                        submenu.classList.remove('is-open');

                        if (menuOverlay !== null && document.querySelectorAll('.nav-main .is-open').length < 1) {
                            menuOverlay.classList.remove('is-open');
                            menuOverlay = null;
                        }
                    })
                });
            }
        }, menuCloseDelay);
    }

    if (navMainDropdowns.length) {
        navMainDropdowns.forEach(element => {
            element.addEventListener('mouseenter', openNavMainDropdown);
            element.addEventListener('mouseleave', closeNavMainDropdown);
            // const link = element.querySelector('a');
            // link.addEventListener('focus', openNavMainDropdown, false);
        })
    }

    if (subNavMainDropdowns.length) {
        subNavMainDropdowns.forEach(element => {
            element.addEventListener('mouseenter', openNavMainDropdown);
            element.addEventListener('mouseleave', closeNavMainDropdown)
            // const link = element.querySelector('a');
            // link.addEventListener('focus', openNavMainDropdown, false);
        })
    }
    

    // Allow mobile trigger buttons to open submenus
    // if (bf_opts.config.submenu_style === 'slide-over') {
    //     document.addEventListener('click', openMobileSubmenuOffcanvas);
    // } else if (bf_opts.config.submenu_style === 'slide-down') {
    //     // document.addEventListener('click', openMobileSubmenuCollapse);
    // }


    // function closeAllMenus()
    // {
    //     const openMenus = navMain.querySelectorAll(".is-open");
    //     if (!openMenus.length) {
    //         return;
    //     }

    //     openMenus.forEach(element => {
    //         requestAnimationFrame(() => {
    //             element.classList.remove('is-open');
    //         });
    //     });
    // }


    // Close menu items with Escape key
    // window.addEventListener(
    //     "keydown",
    //     (event) => {
    //         if (event.defaultPrevented) {
    //         return; // Do nothing if the event was already processed
    //         }

    //         switch (event.key) {
    //         case "Escape":
    //             closeAllMenus();
    //             break;

    //         default:
    //             return; // Quit when this doesn't handle the key event.
    //         }

    //         // Cancel the default action to avoid it being handled twice
    //         event.preventDefault();
    //     },
    //     true,
    // );
}

export default NavMenu;